import { client } from "../../utils/client/graphql";
import { createRatingV2, updateRating as updateRatingMutation } from "@/graphql/mutations";
import { getRating } from "@/graphql/queries";
import { objectWithout, scrapeEmptyFields } from "@/utils/dataCleaning";
import { platform } from "@/platform";
import { CreateRatingInput, GetRatingInput, UpdateRatingInput } from "@/graphql/schema";
import { mutate } from "swr";
import { handleMaybeProgressing } from "@/hooks/gamification/monitoring/progressing";

export const callCreateRating = async (ratingObj: CreateRatingInput) => {
    const { data } = await client.mutate({
        mutation: createRatingV2,
        variables: {
            input: scrapeEmptyFields(ratingObj),
        },
    });

    const rating = data.createRatingV2.item;
    await mutate(["userRating", ratingObj.noteId, ratingObj.userId], rating, { revalidate: false });

    await handleMaybeProgressing(data.createRatingV2);

    return rating;
};

export const callUpdateRating = async (ratingObj: UpdateRatingInput | CreateRatingInput) => {
    const cleanedInput = objectWithout(scrapeEmptyFields(ratingObj) as CreateRatingInput, "type") as UpdateRatingInput;

    const result = await client
        .mutate({
            mutation: updateRatingMutation,
            variables: {
                input: cleanedInput,
            },
        })
        .then(data => data.data.updateRating);

    await mutate(["userRating", ratingObj.noteId, ratingObj.userId], result, { revalidate: false });

    return result;
};

export const fetchUserRating = async ({ noteId, userId }: GetRatingInput) => {
    if (!noteId || !userId) {
        return null;
    }

    const { log } = await platform.analytics.logging();

    return await client
        .query({
            query: getRating,
            variables: {
                input: {
                    noteId,
                    userId,
                },
            },
        })
        .then(data => data.data.getRating)
        .catch(e => {
            log("ERR", e);
            return null;
        });
};
